module.exports = __webpack_public_path__ + "img/illustrator.a60a8282.svg";